export * as contracts from "./contracts";
export * as tokens from "./tokens";
export * as tokenDefinitions from "./tokens/definitions";
export const name = "mainnet";
export const id = 1;
